<template>

  <div style="padding: 30px 0">

    <el-row :gutter="60">
      <el-col :span="24" class="card-01">
        <el-row>
          <el-col :span="24" class="modal_title green">Operace
          </el-col>
        </el-row>

        <el-table
          :data="operations"
          style="width: 100%; word-break: normal;"
          border
          highlight-current-row
        >
           <el-table-column type="expand">
            <template slot-scope="props">
              <ul class="ul_nic">
                <li class="tb-det or">Biopsie: {{ props.row.op_biop_ot }}</li>
                <li class="tb-det grey">Resekce: {{ props.row.op_res }}</li>
                <li class="tb-det grey">MCS: {{ props.row.op_mcs_man_cev }}</li>
                <li class="tb-det grey">Hydrocefalus: {{ props.row.op_hyd_shu }}</li>
                <li class="tb-det grey">Komplikace: {{ props.row.op_res_kompl }}</li>
                <li class="tb-det grey">Endoskop: {{ props.row.op_endo }}</li>
              </ul>                        
            </template>
          </el-table-column>
          <el-table-column
            prop="op_dat_oper"
            label="Datum operace"
            >
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.op_dat_oper }}</span>
            </template>
        </el-table-column>        

        
        </el-table>

      </el-col>
    </el-row>

  </div>

</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  let notifier = new Vue();

  export default {
    name: 'soperations',
    computed: {
      ...mapState({
        patient: state => state.patient,
        operations: state => state.operations,


      }),

      ...mapGetters({

      }),

    },


    data () {
      return {

      }
    },

    methods: {
      ...mapMutations({
        m_modal_checkup: 'm_modal_checkup',
        m_checkup_by_key: 'm_checkup_by_key',

      }),


      ...mapActions({


        }),


      handleChange(value) {
        console.log(value);
      },


      vymaz_data(value) {
        this.checkup[value] = null;
        console.log(value);
      },


      tableRowClassName({row, rowIndex}) {
        if (row.status === 0) {
          return 'row_0';
        } else if (row.status === 1) {
          return 'row_0';
        } else if (row.status === 2) {
          return 'row_0';
        } else if (row.status === 3) {
          return 'row_0';
        } else if (row.status === 4) {
          return 'row_0';
        } else {
          return 'row_0';
        }
      },



      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`)
      },


    },

    beforeMount () {
    },

    created () {
    },

    mounted () {

    },

    beforeDestroy () {
    },


  }
</script>

<style lang="scss">
.el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
}

.el-table .cell{
  line-height: 20px !important;
}

.el-table td, .el-table th {
  padding: 3px 0 !important;
}

.el-table .row_0 {
  background: rgb(253, 253, 253) !important;
}

.el-table .row_1 {
  background: rgb(243, 245, 152) !important;
}

.el-table .row_2 {
  background: rgb(248, 221, 171) !important;
}

.el-table .row_3 {
  background: rgb(248, 186, 157) !important;
}

.el-table .row_4 {
  background: rgb(197, 248, 208) !important;
}

.el-table .row_9 {
  background: rgb(250, 197, 184) !important;
}

.el-table .warning-row {
  background: rgb(241, 175, 52) !important;
}

.el-table .success-row {
  background: #0ada14 !important;
}

.el-table .info-row {
  background: #8fbdf1 !important;
}

.el-select .el-input {
  width: 220px !important;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-form-item {
   margin-bottom: 0 !important;
  }

.el-select {
  padding: 0 20px 10px 0 !important;
}

.el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #7b8d9f;
    cursor: not-allowed;
}

.tb-det {
  padding-left: 40px !important;
  font-size: 13px !important;

  &.light-green {
    color: #617e66 !important;
  }
  &.or {
    color: #b77d5b !important;
  }
  &.grey {
    color: grey !important;
  }  
}

.ul_nic {
  list-style-type: none !important;
}



</style>

